import { createComponent } from '@mtfe/sweet';
import { oadLX } from '@mtfe/pr-oad';

import Dialog, { hideDialog } from '../common/Dialog/script';
import TrafficQRCodeModal from '../TrafficQRCodeModal/script';

import style from './style.less';
import tpl from './dom.html';
import innerTpl from './innerTpl.html';

const TrafficToMiniModal = (wxHtml = '') => {
    try {
        const events = {
            onBtnClick: () => {
                oadLX.mc('b_waimai_vnkf1wlo_mc');
                TrafficQRCodeModal();
                return false;
            },
        };
        const innerData = {
            cashItem: [
                { cashItemKey: '大额推荐金', cash: '17' },
                {
                    cashItemKey: '连签7天必得',
                    cash: '3',
                },
                {
                    cashItemKey: '按实付比例返',
                    cash: '?',
                },
            ],
            btnText: '去小程序，省更多钱',
            wxHtml,
        };

        const modalContent = createComponent(innerTpl, { data: innerData, style }, events);
        const data = {
            renderConfirmDialog: Dialog({
                contentComponent: modalContent,
                onClose: () => {
                    oadLX.mc('b_waimai_4no5be07_mc');
                },
            }),
        };
        createComponent(tpl, { data });
    } catch (error) {
        console.error(error);
        return '';
    }
};

TrafficToMiniModal.hideTrafficInitModal = () => {
    hideDialog();
};

export default TrafficToMiniModal;
